<div class="page-actions">
  <dv-button color="primary" (click)="onSelectGroupClicked()">
    {{ 'Statistics.SelectDepartment' | translate | uppercase }}
  </dv-button>
</div>

<div class="statistics-wrapper">
  <div class="statistics-wrapper__content">
    <div class="statistics-wrapper__content--menu">
      <app-statistics-menu></app-statistics-menu>
    </div>
    <div class="statistics-wrapper__content--tabs">
      <app-statistics-tabs></app-statistics-tabs>
    </div>
  </div>
</div>
